import { httpClient } from './httpClient';
import { ENDPOINTS } from '@api/endpoints';
import { APP_VERSION } from '@config/constants';
import { store } from '@store/index';
import { openSessionExpiredModal } from '@store/slices/authSlice';

export function setupInterceptors(): void {
  httpClient.useRequestInterceptor((config) => {
    const state = store.getState();
    const token = state.auth.tokens?.accessToken;

    if (token && !config.headers?.Authorization) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }

    config.headers = {
      ...config.headers,
      'X-Request-ID': `req-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      'X-App-Version': APP_VERSION,
    };

    return config;
  });

  httpClient.useErrorInterceptor(async (error) => {
    if (error.status === 401) {
      const path = error.requestPath ?? '';
      const isLoginAttempt =
        path === ENDPOINTS.AUTH.LOGIN || path.endsWith(ENDPOINTS.AUTH.LOGIN) || path.includes('/auth/login');
      if (!isLoginAttempt) {
        store.dispatch(openSessionExpiredModal());
      }
    }
    return error;
  });
}
